import { useCallback, useEffect, useState } from "react";
import baseUrl from "../api/baseUrl";
import { isPromotionalSmsEnabled } from "../utils/clinicFeatures";

export const SMS_SETTINGS_UPDATED_EVENT = "sms-settings-updated";

export default function useBirthdayWishesEnabled() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    if (!isPromotionalSmsEnabled()) {
      setEnabled(false);
      setLoading(false);
      return;
    }

    setLoading(true);
    baseUrl
      .get("/client/account/sms-settings")
      .then((res) => {
        if (res?.data?.success) {
          const data = res.data.data;
          setEnabled(
            Boolean(
              data?.configured &&
                data?.status !== false &&
                data?.birthdayEnabled
            )
          );
        } else {
          setEnabled(false);
        }
      })
      .catch(() => setEnabled(false))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();

    const handleSettingsUpdated = () => load();
    window.addEventListener(SMS_SETTINGS_UPDATED_EVENT, handleSettingsUpdated);
    return () => {
      window.removeEventListener(SMS_SETTINGS_UPDATED_EVENT, handleSettingsUpdated);
    };
  }, [load]);

  return { enabled, loading };
}
